module.exports = function() {
  return new Worker("/" + "babel-transpiler.ef09383f.worker.js");
};